import Cookies from 'js-cookie';
export interface OfferTypes {
  isHVO: boolean;
  is3MonthFree: boolean;
  isRVO: boolean;
  isHVOTest: boolean;
}

export const resolveAddressOfferType = (
  addressOfferType: string | undefined,
  offerTypes: OfferTypes = getOfferTypes()
): string | undefined => {
  const { is3MonthFree, isRVO, isHVO, isHVOTest } = offerTypes;

  if (is3MonthFree) return '3monthfree';
  if (isRVO) return 'RVO';
  if (isHVOTest) return 'HVOTest';
  if (isHVO) return 'addressCohort';

  return addressOfferType;
};

export const getOfferTypes = (): OfferTypes => {
  const addressOfferType = typeof window !== 'undefined' ? Cookies.get('addressOfferType') ?? 'default' : 'default';

  const isHVO = compareOfferType('High Value Offer', addressOfferType);
  const is3MonthFree = compareOfferType('3 Months on Us', addressOfferType);
  const isRVO = compareOfferType('ReturnVisitor', addressOfferType);
  const isHVOTest = isHVO && compareOfferType('Test', addressOfferType);

  return {
    is3MonthFree,
    isHVO,
    isRVO,
    isHVOTest,
  };
};

function compareOfferType(keyWord: string, addressOfferTypeCookie?: string): boolean {
  let addressOfferType = addressOfferTypeCookie;

  if (!addressOfferTypeCookie) {
    addressOfferType = typeof window !== 'undefined' ? Cookies.get('addressOfferType') ?? 'default' : 'default';
  }

  return normalizeOfferCode(addressOfferType).includes(normalizeOfferCode(keyWord));
}

export const normalizeOfferCode = (code: string | undefined): string => {
  if (!code) return '';
  //Remove all spaces and convert to lowercase;
  const normalizedCode = code.toLowerCase().trim().replace(/\s+/g, '');
  return normalizedCode ?? '';
};
